import React, { Component } from 'react';
import { Nav, Navbar, NavItem } from 'react-bootstrap';
import { Link } from 'react-router';
import { LinkContainer } from 'react-router-bootstrap';
import './Navigation.css'

import logo from '../resources/img/logo-troi.png'
import logoMobile from '../resources/img/logo-troi-mobile.png'

class Navigation extends Component {

    constructor(props) {
        super(props);

        this.links = [
            {
                to: "/",
                name: "Home"
            }, {
                to: "/universities",
                name: "Universities"
            }, {
                to: "/companies",
                name: "Companies"
            }, {
                to: "/portfolio",
                name: "Portfolio"
            }, {
                to: "/aboutus",
                name: "About Us"
            }, {
                to: "/contact",
                name: "Contact"
            }
        ];
    }

    renderLinkContainers() {
        return this.links.map(function(link, index) {
            return (
                <LinkContainer to={link.to} onlyActiveOnIndex={true} key={index}>
                    <NavItem eventKey={index}>{link.name}</NavItem>
                </LinkContainer>
            );
        });
    }

    render() {
        return (
            <Navbar fixedTop={true} collapseOnSelect>
                <Navbar.Header>
                    <Navbar.Brand>
                        <Link to="/">
                            <img className="hidden-xs" alt="Brand" src={logo} />
                            <img className="visible-xs" alt="Brand" src={logoMobile} />
                        </Link>
                    </Navbar.Brand>
                    <Navbar.Toggle />
                </Navbar.Header>

                <Navbar.Collapse>
                    <Nav pullRight>
                        {this.renderLinkContainers()}
                    </Nav>
                </Navbar.Collapse>
            </Navbar>
        );
    }
}

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js